import production from './resources/production';
import uat from './resources/uat';
import qa from './resources/qa';
import development from './resources/development';
import { Config } from './types';

// 根据不同环境导出不同的配置
const { VUE_APP_CONFIG_TYPE } = process.env;

const config: Config =
  VUE_APP_CONFIG_TYPE === 'production'
    ? production
    : VUE_APP_CONFIG_TYPE === 'uat'
    ? uat
    : VUE_APP_CONFIG_TYPE === 'qa'
    ? qa
    : development;

export default config;
